<template>
  <b-col class="flex-column d-flex m-0 p-0">
    <site-summary></site-summary>
  </b-col>
</template>

<script>
import SiteSummary from '../components/SiteSummary';

export default {
  name: 'dashboard',
  components: {
    SiteSummary
  }
};
</script>

<style>

</style>
